<template>
    <div class="pageMenu">
        <div class="formgrid grid" style="color:black">
            <div class="field col-12 md:col-1" style="border:2px solid red;">
            </div>
            <div class="field col-12 md:col-2">
                Site and Zone Boundary
            </div>
            <div class="field col-12 md:col-1" style="border:2px solid rgba(0, 255, 0, 1);border-style: dashed;">
            </div>
            <div class="field col-12 md:col-2">
                Assessment Area
            </div>
            <div class="field col-12 md:col-1" style="border:2px solid blue;">
            </div>
            <div class="field col-12 md:col-2">
                NSR Residential Building
            </div>
            <div class="field col-12 md:col-1" style="border:2px solid green;">
            </div>
            <div class="field col-12 md:col-2">
                NSR Education Building
            </div>
            <div class="field col-12 md:col-1" style="display: flex;justify-content: center;align-items: center;">
                <div style="border:2px solid black;width:10px;height:10px;border-radius: 5px;"></div>
            </div>
            <div class="field col-12 md:col-1">
                Geographical Centre
            </div>
            <div class="field col-12 md:col-1" style="display: flex;justify-content: center;align-items: center;">
                <div style="border:2px solid orange;width:10px;height:10px;border-radius: 5px;"></div>
            </div>
            <div class="field col-12 md:col-1">
                Notional Source Position
            </div>
            <div class="field col-12 md:col-1" style="display: flex;justify-content: center;align-items: center;">
                <div style="border:2px solid rgba(0, 255, 0, 1);width:10px;height:10px;border-radius: 5px;">
                </div>
            </div>
            <div class="field col-12 md:col-3">
                Noise Receiver (Satisfy Noise Criteria)
            </div>
            <div class="field col-12 md:col-1" style="display: flex;justify-content: center;align-items: center;">
                <div style="border:2px solid red;width:10px;height:10px;border-radius: 5px;"></div>
            </div>
            <div class="field col-12 md:col-3">
                Noise Receiver (Exceed Noise Criteria)
            </div>
        </div>
    </div>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import DateHelper from '@/helper/DateHelper';
import { FALSE } from "ol/functions";
import { defineComponent } from 'vue'; //added by Alex
import Loading from '../index'; //added by Alex
import { store } from '../store/index'; //added by Alex

export default {
    name: 'Legend',

    data() {

        return {
            // below Alex
            isLoading: false,
            fullPage: true,
            canCancel: true,
            useSlot: false,
            loader: 'bars',
            color: '#00632c',
            bgColor: '#ffffff',
            height: 128,
            width: 128,
            //above Alex
            opening: "pi pi-folder-open",
            showProject: true,
            showComponents: false,
            reject: false,
            dialogContent: "",
            dialogButton: "",
            dialogTarget: "",
            dialogDisplay: false
        }
    },

    //below Alex
    components: {
        Loading
    },
    //above Alex
    computed: {

    },

    methods: {

    }
}
</script>

<style lang="less" scoped>
.pageMenu {

    position: fixed;
    right: 10px;
    bottom: 10px;
    background-color: rgba(255, 255, 255, 0.8);

    .p-button {
        width: 3.5rem;
        padding: 0.5rem 0;
        justify-content: center;
        height: 3.5rem;
    }

    .p-button.p-button-icon-only {
        width: 3.5rem;
    }

    .button1 {
        position: fixed;
        left: 10px;
        top: calc(70px + 0.5rem);
    }

    .button2 {
        position: fixed;
        left: 10px;
        top: calc(115px + 0.5rem);
    }

    .button3 {
        position: fixed;
        left: 10px;
        top: calc(175px + 0.5rem);
    }

    .button4 {
        position: fixed;
        left: 10px;
        top: calc(220px + 0.5rem);
    }

    .button5 {
        position: fixed;
        left: 10px;
        top: calc(265px + 0.5rem);
    }

    .button6 {
        position: fixed;
        left: 10px;
        top: calc(310px + 0.5rem);
    }

    .button7 {
        position: fixed;
        left: 10px;
        top: calc(355px + 0.5rem);
    }

    .button8 {
        position: fixed;
        left: 10px;
        top: calc(400px + 0.5rem);
    }

    .button9 {
        position: fixed;
        left: 10px;
        top: calc(445px + 0.5rem);
    }

    .button10 {
        position: fixed;
        left: 10px;
        top: calc(490px + 0.5rem);
    }
}


.button-icon {
    width: 25px;
}

.button-label {
    text-align: center;
    width: 100%
}
</style>
